<template>
	<div class="table-area" id="table-content">
		<ui-load-success
			v-if="loader.overlay"
			:loading="loader.overlayLoading"
			:success="loader.overlaySucess"
		/>

		<payment-modal
			:name="name"
			:modal-name="modalName"
			:modal-options="modalOptions"
			:proposal-settings="proposalSettings"
		/>

		<ui-modal-message
			:name="deleteModalName"
			title="Deseja realmente excluir a(s) Tag(s)?"
			text="Cuidado, esta ação não poderá ser desfeita."
			btn-type="danger"
			btn-text="Confirmar"
			icon="fal fa-trash-alt"
			color-circle="danger"
			icon-circle
			@action="deleteTableItem"
		/>

		<ui-table
			:name="name"
			:columns="table.columns"
			:data="table.data"
			:loading="table.loader"
			:table-header-fixed="false"
			:is-fixed-list="false"
			:last-col-fixed="false"
			:select-column-menu="false"
			tr-component="payment/payment-table/components/payment-table-line"
			not-found-text="Não foi possível encontrar nenhuma opção de Pagamento."
			not-found-icon="fa fa-file-contract"
			custom-load-area
			disable-ref
		/>
	</div>
</template>

<script>
	import { uiTable, uiLoadIndicator } from '@/components/ui'
	import { uiButton } from '@/components/ui/buttons'
	import { uiModalMessage } from '@/components/ui/modal'

	import { proposal, funnel, configuration } from '@/services/axios'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import PaymentModal from './components/payment-modal'
	import {
		makeTablePayment,
		makeColumnsTable,
		makeMonetaryOptions,
		makeOptions,
		considerOptions,
		typeOptions,
		showOptions,
	} from './data'

	const defaultLoader = () => ({
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		name: 'payment-table',

		components: {
			uiModalMessage,
			uiLoadSuccess,
			uiLoadIndicator,
			PaymentModal,
			uiTable,
			uiButton,
		},

		props: {
			/**
			 * Prop: name
			 * Define e garante que o componente possa ser identificado
			 * por nome definido pelo desenvolvedor.
			 */
			name: {
				type: String,
				required: true,
			},
		},

		data() {
			return {
				table: {
					data: [],
					columns: [],
					loader: false,
				},
				loader: { ...defaultLoader() },
				proposalSettings: {},
				monetaryOptions: [],
			}
		},

		async created() {
			this.$root.$on(`${this.name}:update`, async () => {
				this.proposalSettings = await this.getProposalSettings()
				this.updateTable()
			})

			this.$root.$on(`${this.name}:delete-payment`, async (paymentItem) => {
				const config = { formdata: { paymentItem } }
				this.$root.$emit('modal-msg-open-' + this.deleteModalName, config)
			})

			this.table.loader = true
			this.proposalSettings = await this.getProposalSettings()
			this.monetaryOptions = makeMonetaryOptions([...(await funnel.getMonetaryFields()).data])

			this.updateTable()
			this.table.loader = false
		},

		mounted() {
			this.$emit('input', this.table)
		},

		destroyed() {
			this.$root.$off(`${this.name}:update`)
			this.$root.$off(`${this.name}:delete-payment`)
		},

		computed: {
			/**
			 * Dado Computado: modalOptions
			 * Retorna um objeto com as opções dos Selects2 presentes no modal de criação.
			 */
			modalOptions() {
				const m = makeOptions
				return {
					field: [...this.monetaryOptions],
					consider: [...m(considerOptions())],
					type: [...m(typeOptions())],
					show: [...m([...showOptions()])],
				}
			},

			deleteModalName() {
				return this.name + '-delete-modal'
			},

			modalName() {
				return this.name + '-modal'
			},
		},

		methods: {
			async getProposalSettings() {
				return (await proposal.getProposalSettings()).data.value_long
			},

			copyObject(object) {
				return JSON.parse(JSON.stringify(object))
			},

			/**
			 * Método: deleteTableItem(item)
			 * Recebe a linha da tabela que será excluida, trata os loaders
			 * e faz as requisições necessárias para a ação.
			 */
			async deleteTableItem(item) {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					let proposalSettings = this.copyObject(this.proposalSettings)
					proposalSettings.payment.splice(proposalSettings.payment.indexOf(item), 1)

					await configuration.updateConfig('proposalSettings', {
						value_long: proposalSettings,
					})

					this.proposalSettings = await this.getProposalSettings()
					this.updateTable()

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					//...
				} catch (error) {
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},

			/**
			 * Método: updateTable()
			 * Força uma nova montagem da da tabela quando chamado.
			 */
			updateTable() {
				this.table.columns = makeColumnsTable()
				this.table.data = makeTablePayment(
					this.proposalSettings.payment,
					this.monetaryOptions,
					this.name,
				)
			},
		},

		/**
		 * Whatches: value, table
		 * São os responsáveis pela sincronização do v-model do componente.
		 */
		watch: {
			value(value) {
				if (value) this.table = value
			},

			table(value) {
				this.$emit('input', value)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
